function ProductSkeleton() {
  return (
    <div className="landing-product-card caf-product-skeleton" aria-hidden="true">
      <div className="caf-product-skeleton__media landing-product-card__media" />
      <div className="landing-product-card__content">
        <div className="caf-product-skeleton__line caf-product-skeleton__line--lg" />
        <div className="caf-product-skeleton__line caf-product-skeleton__line--md" />
      </div>
      <div className="caf-product-card__footer-panel">
        <div className="caf-product-skeleton__line caf-product-skeleton__line--price" />
        <div className="caf-product-skeleton__line caf-product-skeleton__line--btn" />
      </div>
    </div>
  );
}

export function ProductGridSkeleton({ count = 6 }) {
  return (
    <div className="caf-product-grid">
      {Array.from({ length: count }, (_, index) => (
        <ProductSkeleton key={index} />
      ))}
    </div>
  );
}

export default ProductSkeleton;
